// extracted by mini-css-extract-plugin
module.exports = {"videoEmbed":"VideoEmbed_videoEmbed__qelca","videoEmbed__frame":"VideoEmbed_videoEmbed__frame__Vv4D_"};